var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88513 8.80795C7.33189 9.19058 7 9.83193 7 10.5184V17.9699C7 18.5388 7.44772 19 8 19H12V14.8796C12 13.7418 12.8954 12.8194 14 12.8194C15.1046 12.8194 16 13.7418 16 14.8796V19H20C20.5523 19 21 18.5388 21 17.9699V10.5184C21 9.83193 20.6681 9.19058 20.1149 8.80795L15.1149 5.34978C14.4406 4.88341 13.5594 4.88341 12.8851 5.34978L7.88513 8.80795Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1545 5.37722L10.1149 5.34978C9.44057 4.88341 8.55943 4.88341 7.88513 5.34978L2.88513 8.80795C2.33189 9.19058 2 9.83193 2 10.5184V17.9699C2 18.5388 2.44772 19 3 19H5.70802C5.57422 18.6846 5.5 18.3362 5.5 17.9699V10.5184C5.5 9.31711 6.08081 8.19476 7.04898 7.52514L10.1545 5.37722Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.53cb9a53a65eaf7ac7b640aa3c4c2a86.svg";
export { ForwardRef as ReactComponent };